exports.eocTypes = {
  hacc: {
    code: 'hacc',
    display: 'Home and Community Care',
    system: 'http://snomed.info/sct',
    version: '1.0.0',
  },
  pac: {
    code: 'pac',
    display: 'Post Acute Care',
    system: 'http://snomed.info/sct',
    version: '1.0.0',
  },
  diab: {
    code: 'diab',
    display: 'Post coordinated diabetes program',
    system: 'http://snomed.info/sct',
    version: '1.0.0',
  },
  da: {
    code: 'da',
    display: 'Drug and alcohol rehabilitation',
    system: 'http://snomed.info/sct',
    version: '1.0.0',
  },
  cacp: {
    code: 'cacp',
    display: 'Community-based aged care',
    system: 'http://snomed.info/sct',
    version: '1.0.0',
  },
};